import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NeighborhoodService } from 'src/app/service/Neighborhood.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { Neighborhood } from './neighborhood';

@Component({
  selector: 'app-neighborhood-consulta',
  templateUrl: './neighborhood-consulta.component.html',
  styleUrls: [
    './neighborhood.component.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class NeighborhoodConsultaComponent {

  neighborhoods: Neighborhood[] = [];
  ordemColunasTabela = ['id', 'name', 'excluir', 'editar'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  mensagemErros: String[] = [];
  tipoFiltros: string[] = ['ID', 'Nome'];
  tipoFiltro = 'ID';
  parametro = '';
  consultaRealizada = false;

  constructor(
    private neighborhoodService: NeighborhoodService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
  ) { }

  consultar() {
    const param = this.parametro?.trim() ? this.parametro : '%%';
    this.neighborhoodService.findNeighborhood(this.pagina, this.tamanho, param).subscribe((response) => {
      this.neighborhoods = response.content;
      this.totalElementos = response.totalElements;
      this.pagina = response.number;
      this.consultaRealizada = true;
    });
  }

  listarNeighborhoodService(pagina: number, tamanho: number) {
    this.neighborhoodService.list(pagina, tamanho).subscribe((response) => {
      this.neighborhoods = response.content;
      this.totalElementos = response.totalElements;
      this.pagina = response.number;
      this.consultaRealizada = true;
    });
  }

  novo() {
    this.router.navigate(['/neighborhood/form']);
  }

  editar(id: number) {
    this.router.navigate(['/neighborhood/form', id]);
  }

  private excluir(id: number) {
    this.neighborhoodService.delete(id).subscribe(() => {
      this.mensagemErros = [];
      this.snackBar.open('Bairro excluido com sucesso!', 'Sucesso', {
        duration: 2000,
      });
      if (this.parametro?.trim()) {
        this.consultar();
      } else {
        this.listarNeighborhoodService(this.pagina, this.tamanho);
      }
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    });
  }

  paginar(event: PageEvent) {
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    if (this.parametro?.trim()) {
      this.consultar();
    } else {
      this.listarNeighborhoodService(this.pagina, this.tamanho);
    }
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.excluir(id);
      }
    });
  }
}
